export declare type ScoreSystemType =
  | 'OPEN_VALUE'
  | 'ZERO_TO_FIVE'
  | 'OSAT'
  | 'ZERO_TO_TEN';
